import { EntriModule, ModalsModule } from '@wix/domains-search-suite';
export const ENTRI_ENABLED_BY_SPEC = 'specs.premium.domain.enableEntriInConcierge';
export const divertConnectToEntriEligibility = async (_ref, _ref2) => {
  let domainName = _ref.domainName,
    metaSiteId = _ref.metaSiteId,
    siteName = _ref.siteName;
  let onConnectIntro = _ref2.onConnectIntro,
    onConnectManual = _ref2.onConnectManual,
    onConnectError = _ref2.onConnectError;
  const loaderModal = ModalsModule.internals.domainsSharedModalsController.loaderModal;
  try {
    loaderModal.show({});
    const _await$EntriModule$SD = await EntriModule.SDK.resolveEntriEligibility({
        domain: domainName,
        enabledBySpec: ENTRI_ENABLED_BY_SPEC
      }),
      isEligible = _await$EntriModule$SD.isEligible,
      isSpecEnabled = _await$EntriModule$SD.isSpecEnabled;
    loaderModal.hide();
    if (isEligible && isSpecEnabled) {
      await (onConnectIntro == null ? void 0 : onConnectIntro({
        domainName,
        metaSiteId,
        siteName
      }));
      return;
    }
    await (onConnectManual == null ? void 0 : onConnectManual({
      domainName,
      metaSiteId
    }));
  } catch {
    loaderModal.hide();
    onConnectError == null || onConnectError();
  }
};
//# sourceMappingURL=connectEntriEligibility.js.map